import styled from 'styled-components';
import { CredusText } from 'ui';

import { TestCandidates } from '../../../../../contexts/CandidateContext';

interface ReviewTableProps {
  candidates: Array<TestCandidates>;
}

const ReviewUploadTable = ({ candidates }: ReviewTableProps) => {
  return (
    <Table>
      <tr>
        <Th>
          <CredusText size="md">#</CredusText>
        </Th>
        <Th>
          <CredusText size="md">ID</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Surname</CredusText>
        </Th>
        <Th>
          <CredusText size="md">First name</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Email Address</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Gender</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Mobile No</CredusText>
        </Th>
        {/* <Th>
          <CredusText size="md">Exam Cat</CredusText>
        </Th> */}
        <Th>
          <CredusText size="md">Subject</CredusText>
        </Th>
      </tr>
      {candidates?.map((data: TestCandidates) => (
        <tr>
          <Td>
            <CredusText size="sm">#</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.regNo}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.surname}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.firstName}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.email}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.gender}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.phone}</CredusText>
          </Td>
          {/* <Td>
            <CredusText size="sm">Foundational</CredusText>
          </Td> */}
          <Td>
            <CredusText size="sm">{data?.registeredCourse}</CredusText>
          </Td>
        </tr>
      ))}
    </Table>
  );
};

export default ReviewUploadTable;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  background: #ffeae7;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;
const Td = styled.td`
  background: #fbfbfb;
  height: 58px;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;
